export default {
      id: "deco_lignes-usage",
      viewBox: "0 0 3000 198",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_lignes-usage",
      toString: function () {
        return this.url;
      }
    }